import React, { useEffect, useRef, useState } from 'react';
import api from '../../services/api';
import './DemandeNumeroOr.css';

// ═══════════════════════════════════════════════════════════════════════════
// « Ce dossier n'a pas de N° d'OR » — demandé à la volée après un changement
// de statut (2026-09-03, demande utilisateur).
//
// Le statut est DÉJÀ enregistré quand cette modale s'ouvre : elle ne bloque
// pas le geste, elle le complète. Refuser le changement de statut faute d'OR
// arrêterait la réception, où le numéro n'existe pas encore — c'est justement
// le moment où l'on pose « Réceptionné ».
//
// D'où « Plus tard », qui ferme sans rien écrire : une modale qu'on ne peut pas
// fermer est une modale qu'on apprend à contourner.
// ═══════════════════════════════════════════════════════════════════════════

export default function DemandeNumeroOr({ dossier, onFerme, onEnregistre }) {
  const [valeur, setValeur] = useState('');
  const [envoi, setEnvoi] = useState(false);
  const [erreur, setErreur] = useState('');
  const champRef = useRef(null);

  // Le curseur dans le champ : la modale s'ouvre pour une seule saisie, la
  // réclamer d'un clic supplémentaire serait gratuit.
  useEffect(() => { champRef.current?.focus(); }, []);

  useEffect(() => {
    const surEchap = (e) => { if (e.key === 'Escape') { e.stopPropagation(); onFerme(); } };
    document.addEventListener('keydown', surEchap, true);
    return () => document.removeEventListener('keydown', surEchap, true);
  }, [onFerme]);

  const enregistrer = async (e) => {
    e?.preventDefault();
    const num = valeur.trim();
    if (!num || envoi) return;
    setEnvoi(true);
    setErreur('');
    try {
      const { data } = await api.patch(`/planning/interventions/${dossier.id}/numero-or`, { numero_or: num });
      onEnregistre(data.numero_or || num);
    } catch (err) {
      setErreur(err.response?.data?.error || 'Enregistrement impossible.');
      setEnvoi(false);
    }
  };

  const vehicule = [dossier.immatriculation, dossier.marque, dossier.modele].filter(Boolean).join(' · ');
  const client = dossier.client || [dossier.client_prenom, dossier.client_nom].filter(Boolean).join(' ');

  return (
    <div className="dor-overlay" onClick={(e) => { e.stopPropagation(); onFerme(); }}>
      <form className="dor-boite" onClick={(e) => e.stopPropagation()} onSubmit={enregistrer}>
        <div className="dor-tete">
          <h3>Numéro d'OR manquant</h3>
          <button type="button" className="dor-fermer" onClick={onFerme} aria-label="Fermer">✕</button>
        </div>
        <div className="dor-corps">
          {/* Formulation directe (demande utilisateur) : la consigne d'abord,
              le contexte ensuite. Le statut qui vient d'être posé n'est plus
              rappelé — après un glisser-déposer, c'est le DOSSIER qu'on a besoin
              d'identifier, pas la colonne où on vient de le lâcher. */}
          <p className="dor-contexte">Merci de le renseigner.</p>
          {(client || vehicule) && (
            <p className="dor-dossier">{client}{client && vehicule ? ' — ' : ''}{vehicule}</p>
          )}
          <label htmlFor="dor-champ">Numéro d'OR</label>
          <input
            id="dor-champ"
            ref={champRef}
            value={valeur}
            onChange={(e) => { setValeur(e.target.value); setErreur(''); }}
            placeholder="Ex. 011041705"
            autoComplete="off"
            inputMode="numeric"
          />
          {erreur && <p className="dor-erreur">⚠️ {erreur}</p>}
        </div>
        <div className="dor-pied">
          <button type="button" className="dor-plus-tard" onClick={onFerme}>Plus tard</button>
          <button type="submit" className="dor-valider" disabled={!valeur.trim() || envoi}>
            {envoi ? 'Enregistrement…' : 'Enregistrer'}
          </button>
        </div>
      </form>
    </div>
  );
}
